import { render, staticRenderFns } from "./StockItems.vue?vue&type=template&id=e89094a0&scoped=true"
import script from "./StockItems.vue?vue&type=script&lang=js"
export * from "./StockItems.vue?vue&type=script&lang=js"
import style0 from "./StockItems.vue?vue&type=style&index=0&id=e89094a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89094a0",
  null
  
)

export default component.exports